import React, { Component } from 'react'

class SingleSlide extends React.Component{
  render() {
    return (
      <li style={{backgroundImage: this.props.backgroundimg}}>
      <div className="overlay" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 col-md-offset-5 col-md-pull-5 col-sm-14 col-xs-14 js-fullheight slider-text">
            <div className="slider-text-inner js-fullheight">
              <div className="desc">
                <h1  style={{fontSize:60, fontFamily:"Consolas"}}>{this.props.texts[0]} <br />{this.props.texts[1]}</h1>
                  <p><a className="btn btn-primary btn-learn" href={this.props.link} target={this.props.target} rel="noopener noreferrer">{this.props.buttonText}</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    )
  }
}

export default class Slides extends Component {
  render() {
    return (
      <div>
        <section id="colorlib-hero" className="js-fullheight" data-section="Home">
          <div className="flexslider js-fullheight">
            <ul className="slides">
              <SingleSlide texts={["Hi!", "I'm Tianfeng"]} backgroundimg="url(images/img_bg.jpg)" link="#/CV" target="_blank" buttonText="View CV"></SingleSlide>
              <SingleSlide texts={["I'm working", "on neuroscience"]}  backgroundimg="url(images/bg2.png)" link="#Projects" target="_self" buttonText="My projects"></SingleSlide>
              <SingleSlide texts={["I'm also studying", "mathematics"]} backgroundimg="url(images/bg3.png)" link="#Collections" target="_self" buttonText="Collections"></SingleSlide>

            </ul>
          </div>
        </section>
      </div>
    )
  }
}
